import React from "react";

export interface HorizontalProgressBarProps {
  label: string;
  value: number;
  maxValue?: number;
  className?: string;
  showValue?: boolean;
  animated?: boolean;
}

const HorizontalProgressBar = (props: HorizontalProgressBarProps) => {
  const { label, value, maxValue, className = "", showValue = true, animated = true } = props;

  const percentage = maxValue ? Math.min((value / maxValue) * 100, 100) : 100;

  return (
    <div
      className={`horizontal-progress-bar ${className}`}
      style={{ "--progress-width": `${percentage}%` } as React.CSSProperties}
    >
      <div className="horizontal-progress-bar__label">{label}</div>
      <div className="horizontal-progress-bar__container">
        <div className={`horizontal-progress-bar__fill ${animated ? "horizontal-progress-bar__fill--animated" : ""}`} />
      </div>
      {showValue && <div className="horizontal-progress-bar__value">{value}</div>}
    </div>
  );
};

export default HorizontalProgressBar;
